<template>
  <div class="container">
    <content-header :data="[{text:'用户列表', path: ''}]"></content-header>
    <div class="content">
      <div class="content-bar">
        <div class="search-entry">
          <el-button type="primary" icon="plus" @click="initNewHandle">添加</el-button>
        </div>
        <div class="search-entry">
            <el-input
              placeholder="请输入查询关键字"
              v-model="keywords">
            </el-input>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="searchHandle">查询</el-button>
        </div>
        <div class="search-btn">
          <el-button type="primary" @click="importHandle">导入用户</el-button>
        </div>
      </div>
      <!-- 列表区域 -->
      <div class="content-list">
        <el-table
          :data="tableData"
          border
          stripe>
          <el-table-column
            prop="name"
            label="姓名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="region_name"
            label="区域">
          </el-table-column>
          <el-table-column
            prop="department_name"
            label="部门">
          </el-table-column>
          <!-- <el-table-column
            prop="name"
            label="职务"
            width="110">
          </el-table-column> -->
          <el-table-column
            prop="role_name"
            label="角色">
          </el-table-column>
          <el-table-column
            prop="mobile"
            label="手机号码"
            width="130">
          </el-table-column>
          <!-- el-table-column
            prop="modifier_name"
            label="操作人"
            width="100">
          </el-table-column>
          <el-table-column
            prop="modified"
            label="操作时间"
            width="180">
          </el-table-column -->
          <el-table-column
            fixed="right"
            label="操作"
            width="200">
            <template slot-scope="scope">
              <el-button @click="editHandle(scope)" type="text" size="small" v-if="scope.row.id > 1">修改</el-button>
              <!--el-button @click="freezeHandle(scope)" type="text" size="small" v-if="scope.row.id > 1">{{ scope.row.is_active == 1 ? '冻结' : '解冻' }}</el-button-->
              <el-button @click="resetHandle(scope)" type="text" size="small" v-if="scope.row.id > 1">重置密码</el-button>
              <el-button @click="deleteHandle(scope)" type="text" size="small" v-if="scope.row.id > 1">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination" v-if="total > pageSize">
          <el-pagination
            @size-change="pageSizeChange"
            @current-change="curPageChange"
            :current-page="curPage"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </div>
      <!-- 新建用户弹出区域 -->
      <div class="new-wrap">
        <el-dialog :title="curObj.row.id ? '修改用户' : '添加用户'" :visible.sync="isNewShow">
          <el-form :model="newObj" :rules="newObjRules" ref="newObjForm" label-position="right" label-width="0px">
            <el-form-item prop="name" label="用户名" :label-width="formLabelWidth">
              <el-input name="name" v-model="newObj.name" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="region" label="区域" :label-width="formLabelWidth">
              <el-select name="region" v-model="newObj.region" value-key="id" placeholder="请选择区域">
                <el-option v-for="item in regionOpts" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="department" label="部门" :label-width="formLabelWidth">
              <el-select name="department" v-model="newObj.department" value-key="id" placeholder="请选择部门">
                <el-option v-for="item in departmentOpts" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="role" label="角色" :label-width="formLabelWidth">
              <el-select name="role" v-model="newObj.role" value-key="id" placeholder="请选择角色">
                <el-option v-for="item in roleOpts" :key="item.id" :label="item.name" :value="item"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item prop="tel" label="手机号码" :label-width="formLabelWidth">
              <el-input name="tel" v-model="newObj.tel" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="qq" label="QQ" :label-width="formLabelWidth">
              <el-input name="qq" v-model="newObj.qq" auto-complete="off"></el-input>
            </el-form-item>
            <el-form-item prop="email" label="邮箱" :label-width="formLabelWidth">
              <el-input name="email" v-model="newObj.email" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <span style="float:left">请用姓名或者手机号和密码登录，默认密码123456</span>
            <el-button @click="cancelHandle">取 消</el-button>
            <el-button type="primary" @click="confirmHandle">确 定</el-button>
          </div>
        </el-dialog>
      </div>
      <div>
        <el-dialog title="导入用户" width="50%" :visible.sync="isImportShow">
          <el-upload
            class="upload-demo"
            :headers = "importHeader"
            :action="importUrl"
            :show-file-list="false"
            :on-success="importSuccess"
            :on-progress="importProgress"
            :before-upload="beforeImport"
            :on-error="importError"
            >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传指定格式的Excel文件，注意不要修改第1行(表头)的内容<a href="/static/tpl/用户信息导入模板v1.0.xlsx">模板文件下载</a></div>
          </el-upload>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
  import constants from 'config/constants'
  import sessionstorage from 'utils/sessionstorage'
  import urls from 'config/urls'
  import UserModel from 'models/user'
  import DepartmentModel from 'models/department'
  import RegionModel from 'models/region'
  import RoleModel from 'models/role'
  import { mapState } from 'vuex'
  import {showLoading, hideLoading} from 'components/loading'

  export default {
    data () {
      return {
        keywords: '',
        tableData: [],
        regionOpts: [],
        departmentOpts: [],
        roleOpts: [],
        isNewShow: false,
        newObj: {
          name: '',
          department: {},
          region: {},
          qq: '',
          email: '',
          tel: '',
          role: {}
        },
        formLabelWidth: '80px',
        newObjRules: {
          name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
          department: [{ required: true, message: '请输入部门', type: 'object', trigger: 'blur' }],
          // qq: [{ required: true, trigger: 'blur' }],
          // email: [{ required: true, trigger: 'blur', validator: validateEmail }],
          tel: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
          role: [{ required: true, message: '请输入角色', type: 'object', trigger: 'blur' }]
        },
        curPage: 1,
        pageSize: 10,
        total: 0,
        curObj: {
          row: {}
        },
        isEdit: false,
        editObj: {},
        editIndex: null,
        key: '',
        isImportShow: false,
        importUrl: constants.basic.domain + urls.user.import,
        importHeader: {},
      }
    },
    created () {
      console.log('user page created')
      sessionstorage.getItem('token').then(token => {
        if (!token) return
        this.importHeader = {Authorization: 'Bearer ' + token}
      })
      //
      this.getObjList()
      DepartmentModel.find({curPage: 1, pageSize: 1000}).then(res => {
        this.departmentOpts = res.item_list
      })
      RegionModel.find({curPage: 1, pageSize: 1000}).then(res => {
        this.regionOpts = res.item_list
      })
      RoleModel.find().then(res => {
        this.roleOpts = res.role_list
      })
    },
    computed: {
      ...mapState({
        userInfo: state => state.user.info
      }),
    },
    watch: {
      isNewShow (n) {
        if (n) return
        for (let key of Object.keys(this.newObj)) {
          this.newObj[key] = key === 'school' ? [] : ''
        }
      }
    },
    methods: {
      importError (err, file, fileList) {
        console.log(err)
        this.$message({ message: '上传失败', type: 'error' })
      },
      importProgress (e, file, fileList) {
        console.log(e)
        if (e.percent === 100) {
          this.isImportShow = false
          showLoading()
        }
      },
      importSuccess (response, file, fileList) {
        console.log(response)
        if (response.code === 200) {
          hideLoading()
          this.$message({ message: response.data, type: 'success' })
          this.getObjList()
          this.isImportShow = false
        } else {
          hideLoading()
          this.$message({ message: response.data, type: 'error', dangerouslyUseHTMLString: true, duration: 0, showClose: true })
          this.isImportShow = false
        }
      },
      beforeImport (file) {
        console.log(file)
        // var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
        //        const extension = testmsg === 'xls'
        //        const extension2 = testmsg === 'xlsx'
        const isExcel = (file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet')
        const isLt2M = file.size / 1024 / 1024 < 2

        if (!isExcel) {
          this.$message.error('上传文件只能是Excel（.xlsx）格式!')
        }
        if (!isLt2M) {
          this.$message.error('上传文件大小不能超过 2MB!')
        }
        return isExcel && isLt2M
      },
      //
      pageSizeChange (size) {
        this.pageSize = size
        this.getObjList()
      },
      curPageChange (page) {
        this.curPage = page
        this.getObjList()
      },
      getObjList (opts) {
        const _opts = {
          cur_page: this.curPage,
          page_size: this.pageSize,
          keywords: encodeURIComponent(this.keywords)
        }
        // 合并参数
        if (typeof opts === 'object') Object.assign(_opts, opts)
        //
        UserModel.find(_opts).then(res => {
          this.tableData = res.user_list
          this.total = res.total
        })
      },
      cancelHandle () {
        this.$refs.newObjForm.resetFields()
        this.isNewShow = false
      },
      editHandle (data) {
        this.curObj = data

        const _department = this.departmentOpts.filter(item => {
          return item.id === data.row.department_id
        })
        const _region = this.regionOpts.filter(item => {
          return item.id === data.row.region_id
        })
        const _role = this.roleOpts.filter(item => {
          return item.id === data.row.role_id
        })
        this.newObj = {
          name: data.row.username,
          department: _department[0],
          region: _region[0],
          qq: data.row.qq,
          email: data.row.email,
          tel: data.row.mobile,
          role: _role[0]
        }
        this.isNewShow = true
        this.isEdit = true
        this.editObj = data.row
        this.editIndex = data.$index
      },
      freezeHandle (item) {
        this.$confirm(!item.row.is_active ? '确认解冻' : '确认冻结？')
          .then(_ => {
            this.activeHandle(item)
          })
          .catch(_ => {})
      },
      activeHandle (item) {
        UserModel.activate({
          id: item.row.id,
          is_active: item.row.is_active === '0' ? '1' : '0'
        }).then(() => {
          this.tableData[item.$index].is_active = item.row.is_active === '0' ? '1' : '0'
          this.tableData.push(0)
          this.tableData.pop()
          this.$message({ message: item.row.is_active === '1' ? '解冻成功' : '冻结成功', type: 'success' })
        })
      },
      resetHandle (item) {
        this.$confirm('确认重置 ' + item.row.username + ' 的密码?')
          .then(_ => {
            UserModel.resetPassword({
              id: item.row.id,
            }).then(() => {
              this.$message({ message: '重置成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '重置失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      deleteHandle (item) {
        this.$confirm('确认删除 ' + item.row.username + '?')
          .then(_ => {
            UserModel.delete({
              id: item.row.id,
            }).then(() => {
              this.getObjList()
              this.$message({ message: '删除成功', type: 'success' })
            }).catch(_ => {
              this.$message({ message: '删除失败', type: 'error' })
            })
          })
          .catch(_ => {})
      },
      newObjHandle () {
        const opts = {
          name: this.newObj.name,
          department_id: this.newObj.department.id,
          region_id: this.newObj.region.id,
          qq: this.newObj.qq,
          email: this.newObj.email,
          mobile: this.newObj.tel,
          role_id: this.newObj.role.id
        }
        if (this.isEdit) {
          opts.id = this.editObj.id
          // 更新用户信息
          UserModel.update(opts).then(() => {
            this.getObjList()
            this.successHandle('更新成功')
          }).catch(err => {
            this.$message({ message: err.message, type: 'error' })
          })
          return
        }
        // 创建新用户
        UserModel.create(opts).then(res => {
          this.getObjList()
          this.successHandle('添加成功')
        }).catch(err => {
          this.$message({ message: err.message, type: 'error' })
        })
      },
      successHandle (msg) {
        this.isNewShow = false
        this.$message({ message: msg, type: 'success' })
      },
      confirmHandle () {
        this.$refs.newObjForm.validate(valid => {
          if (!valid) return
          this.newObjHandle()
        })
      },
      initNewHandle () {
        this.curObj = { row: {} }
        this.isNewShow = true
        this.isEdit = false
      },
      searchHandle () {
        this.curPage = 1
        this.getObjList()
      },
      importHandle () {
        this.isImportShow = true
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.container
  min-height: 100%
  background-color: #fff
  .content
    .content-bar
      padding: 20px
      .search-entry
        display: inline-block
        vertical-align: top
        margin-right: 20px
        span
          display: inline-block
          vertical-align: top
          line-height: 36px
        .entry-box
          display: inline-block
          vertical-align: top
          width: 140px
          &.username
            width: 140px
      .search-btn
        display: inline-block
        vertical-align: top
    .content-list
      padding-left: 20px
      padding-right: 20px
      padding-bottom: 40px
      .pagination
        margin-top: 10px
    .new-wrap
      .el-input
        width: 300px
      .form-title
        padding-top: 10px
        padding-bottom: 10px
        font-size: 12px
        color: #aaa
      .check-title
        text-align: right
        display: inline-block
        vertical-align: middle
        width: 90px
        font-size: 14px
        color: #48576a
        line-height: 1
        padding: 11px 12px 11px 0
        box-sizing: border-box
</style>



// WEBPACK FOOTER //
// src/views/User.vue